export function handleUpdateStateWithAcceptedConsent(state, action) {
  const { appointmentConsentId, affectedAppointmentIds } = action.payload;

  const newArr = [...state.list];

  if (appointmentConsentId && affectedAppointmentIds)
    newArr.forEach(item => {
      if (affectedAppointmentIds.includes(item.id)) {
        const targetConsent = item.consentsAssignment.consents.filter(
          consent => consent.id === appointmentConsentId,
        );
        if (targetConsent && targetConsent[0]) {
          targetConsent[0].accepted = true;
        }
      }
    });

  return {
    ...state,
    list: newArr,
  };
}



// WEBPACK FOOTER //
// ./src/components/Healthboard/utils/handleUpdateStateWithAcceptedConsent.js